import React, {FC} from 'react';
import styled from 'styled-components';

import {center} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {AttachmentVisualContentTypesEnum} from '../../../../../models/api/attachmentModel';
import {fileTypeIcons} from '../../../viewer/activity/attachments/attachmentFileIcon';

/*
 * Types.
 */

interface CellSummaryAttachmentIconProps {
  contentType?: AttachmentVisualContentTypesEnum;
}

/*
 * Style.
 */

const StyledIconDiv = styled.div`
  grid-area: bottom-left;
  height: 100%;
  ${center()};
`;

/*
 * Component.
 */

export const CellSummaryAttachmentIcon: FC<CellSummaryAttachmentIconProps> = (props) => (
  <StyledIconDiv>
    <img
      alt="Attachment"
      src={fileTypeIcons[props.contentType || AttachmentVisualContentTypesEnum.GENERIC]}
    />
  </StyledIconDiv>
);
